import React from "react";
import theme from "@monorepo/styles/theme";
import { Box, SxProps } from "@mui/material";

type TProps = {
  className?: string;
  id?: string;
  ref?: React.Ref<HTMLDivElement>;
  sx?: SxProps;
};

export const ScrollableContainer: React.FC<TProps> = React.forwardRef(({ children, className, id, sx }, ref) => {
  return (
    <Box
      sx={{
        display: "grid",
        overflow: "auto",
        maxHeight: "100%",
        ...sx,
        [theme.breakpoints.down("md")]: {
          height: "auto",
          maxHeight: "unset",
        },
      }}
      className={className}
      id={id}
      ref={ref}
    >
      {children}
    </Box>
  );
});
